'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DepositTracker = DepositTracker;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _messageBus = require('@wh/message-bus');

var _constants = require('../../constants');

var _currencySignFormatter = require('../../utils/currencySignFormatter');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DepositTracker(_ref) {
  var currencyCode = _ref.currencyCode,
      minDeposit = _ref.minDeposit,
      maxDeposit = _ref.maxDeposit,
      jurisdiction = _ref.jurisdiction,
      closeQuickDeposit = _ref.closeQuickDeposit,
      _ref$t = _ref.t,
      t = _ref$t === undefined ? function () {
    var ctx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return function (msg) {
      return '' + ctx + msg;
    };
  } : _ref$t;

  var translate = t(_constants.TRANSLATION_CONTEXT);

  var openDepositLimitsPage = (0, _react.useCallback)(function (event) {
    event.preventDefault();
    (0, _messageBus.publish)('wh.myAccount.command.dropdown.open', { path: 'depositLimitsPage' });
    closeQuickDeposit();
  }, []);

  return _react2.default.createElement(
    'div',
    { className: 'qd-deposit-tracker' },
    _react2.default.createElement(
      'div',
      { className: 'qd-deposit-tracker__title' },
      translate('FORM_DEPOSIT_TRACKER_TITLE')
    ),
    _react2.default.createElement(
      'div',
      null,
      translate('FORM_DEPOSIT_TRACKER_MIN'),
      ' ',
      (0, _currencySignFormatter.currencySignFormatter)(minDeposit, currencyCode)
    ),
    _react2.default.createElement(
      'div',
      null,
      translate('FORM_DEPOSIT_TRACKER_MAX'),
      ' ',
      (0, _currencySignFormatter.currencySignFormatter)(maxDeposit, currencyCode),
      _react2.default.createElement(
        'span',
        null,
        ' ' + translate('FORM_DEPOSIT_TRACKER_REMAINING_LIMIT')
      )
    ),
    jurisdiction === 'com' && _react2.default.createElement(
      'a',
      { onClick: openDepositLimitsPage, className: 'qd-deposit-tracker__link' },
      translate('FORM_DEPOSIT_LIMIT_LINK')
    )
  );
}